<template>
  <div class="home_nav_wrap">
    <div class="headNav">
      <div class="head_wrap">
        <div class="mainContent">
          <img
            @click="getActive('Inicio')"
            class="logo"
            src="@/assets/imgs/lalanita_logo_1.webp"
            alt=""
          />
          <ul class="nav">
            <li :class="activeNav == 'Inicio' ? 'active' : ''">
              <a @click="getActive('Inicio')">INICIO</a>
              <div class="line"></div>
            </li>
            <li :class="activeNav == 'Aviso' ? 'active' : ''">
              <a @click="getActive('Aviso')">PREVENCIÓN DE FRAUDE</a>
              <div class="line"></div>
            </li>
            <li :class="activeNav == 'sobre' ? 'active' : ''">
              <a @click="getActive('sobre')">CENTRO DE AYUDA</a>
              <div class="line"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/homenav.scss";

export default {
  name: "headNav",
  props: ["activeNav"],
  data() {
    return {
      // active: "Inicio",
    };
  },
  created() {
    // this.active = this.activeNav;
    // console.log(nav, this.active);
    // if (nav) {
    //   this.active = nav;
    // } else {
    //   localStorage.setItem('activeNav', "Inicio");
    // }
  },
  methods: {
    getActive(val) {
      // this.activeNav = val;
      let url = "";
      switch (val) {
        case "Inicio":
          url = "/home";
          break;
        case "sobre":
          url = "/about";
          break;
        case "Aviso":
          url = "/notice";
          break;
        case "loan":
          url = "/loan";
          break;
        case "ayuda":
          url = "/help";
          break;
      }
      this.$router.push(url);
    },
  },
};
</script>

<style>
</style>
